import React, { FC, Fragment, useMemo, useState } from 'react';
import { supplierDirectoryTemplate } from 'apollo/templates/supplier-request';
import { SUPPLIER_SERVICES } from 'models/organization-profile';
import { SupplierDirectoryLab } from 'models/supplier-request';
import { DirectoryBrowserConfig } from './directory-browser-config';
import DirectoryBrowser from './directory-browser.component';
import RequestSupplierDialog from './request-supplier-dialog.component';
import SupplierConnectionAction from './supplier-connection-action.component';
import SupplierOtherService from './supplier-other-service.component';

/**
 * DD-3662: labs that list themselves as suppliers. Search, filter on services and
 * distance, read a profile and ask a lab to become this lab's supplier.
 */
const SupplierBrowser: FC = () => {
    const [toRequest, setToRequest] = useState<SupplierDirectoryLab>();

    const config = useMemo<DirectoryBrowserConfig>(
        () => ({
            query: supplierDirectoryTemplate,
            field: 'supplierDirectory',
            services: SUPPLIER_SERVICES,
            serviceLabelKey: (service) => `lab-settings:SUPPLIER_SERVICE_${service}`,
            serviceTooltipKey: (service) => `lab-settings:SUPPLIER_SERVICE_${service}_INFO`,
            texts: {
                noneListed: 'client-directory:NO_SUPPLIERS_LISTED',
                noneMatch: 'client-directory:NO_SUPPLIERS_MATCH',
                hideConnected: 'client-directory:HIDE_CONNECTED_SUPPLIERS',
                mapTitle: 'client-directory:SUPPLIER_MAP_TITLE',
                mapOnlyLocated: 'client-directory:SUPPLIER_MAP_ONLY_LOCATED',
                noDescription: 'client-directory:SUPPLIER_NO_DESCRIPTION',
            },
            // The directory lists this query's labs, so each is a SupplierDirectoryLab.
            renderAction: (lab, closeDetails) => (
                <SupplierConnectionAction
                    lab={lab as SupplierDirectoryLab}
                    onRequest={(requested) => {
                        closeDetails?.();
                        setToRequest(requested);
                    }}
                />
            ),
            renderDetails: (lab) => <SupplierOtherService lab={lab as SupplierDirectoryLab} />,
        }),
        [],
    );

    return (
        <Fragment>
            <DirectoryBrowser config={config} />
            <RequestSupplierDialog lab={toRequest} onClose={() => setToRequest(undefined)} />
        </Fragment>
    );
};

export default SupplierBrowser;
